<template>
    <el-dialog  title="新增协议信息" :visible.sync="showBlock" :destroy-on-close="true" width="600px" :close-on-click-modal="false" :before-close="closedBtn">
        <el-form :model="formDate" ref="formDate" status-icon :rules="rules" label-width="70px" class="demo-ruleForm">
            <el-form-item  label="协议名称" prop="name" >
                <el-input v-model="formDate.name" :size="this.$store.state.popSize" maxlength="30" placeholder="请输入协议名称" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item  label="所属公司" prop="company" >
                <el-select  v-model="formDate.company"    filterable  remote reserve-keyword placeholder="请输入关键词" style="width:100%;" :remote-method="remoteMethod"   >
                   <el-option v-for="item in list"  :key="item.selectName" :label="item.selectName" :value="item.selectName"> </el-option>
                </el-select>
            </el-form-item>
            <el-form-item  label="使用工厂" prop="factoryIds">
                <SelectCheck keyVal="factory" ref="factory" value :size="this.$store.state.popSize" title=""  placeholder="请选择使用工厂"  left="0" right="0" :options="optionsList"  width="500" @getVal="getFactory" />
            </el-form-item>
            <div class="common-flex">
                <div class="verTitle">协议版本</div>
                <div class="warp-version">
                    <div class="version" :class='[item.mark ? "error":""]' v-for="(item,index) in listArray" :key="index">
                        <el-input style="width:145px" v-model="item.name"  maxlength="10" placeholder="请输入协议版本" autocomplete="off"/>
                        <i v-if="(listArray.length-1==index)" class="el-icon-circle-plus-outline" @click="addv"></i>
                        <i v-else class="el-icon-remove-outline" @click="reduc(index)"></i>
                        <span v-if="item.mark" class="tishi">协议不可为空</span>
                    </div>
                </div>
            </div>
            <el-form-item  label="使用指南" prop="descr">
                <PDF @getUpload="getUpload" />
            </el-form-item>
            <div class="warp-btn">
                <el-form-item>
                    <div  class="dialog-footer">
                        <el-button @click="closedBtn">取消</el-button>
                        <el-button type="primary" @click="submitForm('formDate')">提交</el-button>
                    </div>
                </el-form-item>
            </div>
        </el-form>
    </el-dialog>
</template>
<script>
 
  import {url,iotApi} from '@/utils/config'
  import {postFun,putFun} from '@/utils/httpFun'
  import PDF from './protocol-upload-Pdf.vue'
  let checkname = function(rule, value, callback){
    if (!value) {
        return callback(new Error("协议名称不可为空"));
    }
    callback()    
  }

  let checkCompany = function(rule, value, callback){
    if (!value) {
        return callback(new Error("所属公司不可为空"));
    }
    callback()    
  }
  export default{
     components:{
        PDF
     },
     props:{
        list:{
          type:Array,
          default:()=>[]  
        }
     },
     data(){
       return{
            rules:{
                name:[{validator:checkname, trigger:'blur'}],
                company:[{validator:checkCompany, trigger:'blur'}],
            },
            loading:true,
            optionsList:[],
            listArray:[{name:"",mark:false}], //协议版本   
            formDate: {
                name:"",               //协议名称
                company:"",            //所属公司
                resouces:"",           //使用材料操作手册
                enabled:1,             //启用禁用 1启用 0禁用
                hasDelete:0,           //是否删除 1删除 0未删 
                factoryIds:[]          //工厂 
               
            },
            showBlock: false
       }
     },
    
     created(){
       
     },
     methods:{
    
        //重置输入框信息
        resetForm(formDate) {
            this.$refs[formDate].resetFields();
        },

        //提交
        submitForm(formDate) {
            let list = this.listArray
                for(var i in list){
                   if(!list[i].name){
                      list[i].mark = true
                   }else{
                      list[i].mark = false
                   }
                }
            this.listArray =  list  
            this.$refs[formDate].validate((valid) => {
            if (valid) {
                  this.addMess()
                } else {
                  console.log('error submit!!');
                  return false;
                }
            });
        },

        //提交新增
        async addMess(){
            let val = []
            let parms = {
                name:this.formDate.name,              //协议名称
                company:this.formDate.company,        //所属公司
                resouces:this.formDate.resouces,      //使用材料
                enabled:this.formDate.enabled,        //启用禁用
                hasDelete:this.formDate.hasDelete,
                factoryIds:this.formDate.factoryIds,   //工厂的ID
                protocolVersions:this.listArray        //协议版本   
            }
            let list = this.listArray
                for(var i in list){
                   if(!list[i].name){
                      list[i].mark = true
                   }else{
                      list[i].mark = false
                      val.push(list[i].name)
                   }
                }
            if(val.length!= list.length){
                return
            }    
            this.listArray =  list       
             
            for(var i in parms.protocolVersions){
                delete parms.protocolVersions[i].mark
            }
            parms.operator = this.$store.state.operator
            await postFun(iotApi.DEALADD,parms,res=>{
               this.$parent.getList()
               this.$parent.getCompany()
               this.closedBtn()    
            })
        },
        
        //
        remoteMethod(ev){
           this.formDate.company =  ev
        },

        //开启弹窗
        showBlockMe(ev){
           this.showBlock = true  
           let list =  ev
           let listArray = []
           for(var i in list){
               listArray.push({indexNo:list[i].id+"",selectName:list[i].factoryName+""})
           }
           this.optionsList = listArray
           this.$nextTick(res=>{
              this.$refs.factory.setVal([listArray[0].indexNo])
              this.formDate.factoryIds = [listArray[0].indexNo]
           })
        },
        
        //获取使用工厂
        getFactory(ev){
           this.formDate.factoryIds = ev.val
        },
        
        //新增
        addv(){
            this.listArray = [...this.listArray,...[{name:"",mark:false}]]
        },
        //删除
        reduc(ev){
            this.listArray.splice(ev,1)
        },
        
        //上传成功的文件
        getUpload(ev){
            this.formDate.resouces = ev.val[0]
        },

        //关闭弹窗并刷新
        closedBtn(){
            this.formDate.name = ''
            this.formDate.company = ""
            this.formDate.resouces = ''
            this.listArray=[{name:""}] 
            this.showBlock = false
        }
     }
  }
</script>
<style scoped lang="scss">
   .dialog-footer{
       display: flex;
       justify-content: flex-end;
   }

   .name{
        font-family: PingFangSC-Regular;
        font-size: 16px;
        color: #4D5C72;
        letter-spacing: 0;
   }
   .warp-version{
     display: flex;
     flex-wrap: wrap;
     width:490px;
     position: relative;
     z-index: 10;

   }
   .verTitle{
     margin-right: 14px;
     position: relative;
     top: 8px;
   }
   .version{
     margin-bottom: 24px;
     position: relative;
     width: 145px;
     margin-right: 15px;
    
     }
     .version.error{
        ::v-deep .el-input__inner{
          border: 1px solid #F56C6C
      }
     .tishi{
            color: #F56C6C;
            font-size: 12px;
            line-height: 1;
            padding-top: 4px;
            position: absolute;
            top: 100%;
            left: 0; 
    }   
   }
   .el-icon-circle-plus-outline{
      font-size: 22px;
      margin-left: 5px;
   }
   .el-icon-circle-plus-outline,.el-icon-remove-outline{
      font-size: 18px;
      margin-left:6px;
      color: #ADADAD;
      position: absolute;
      top:11px;
      right:10px;

   }
   .warp-btn{
    .el-form-item {
        margin-bottom:0px!important;
     }
   }
   
</style>